var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.data)?_c('div',{staticClass:"close-position"},[_c('p',{class:'action ' + _vm.action.toLowerCase(),on:{"click":function($event){return _vm.closeTrade(_vm.params.data)}}},[_vm._v(" CLOSE "+_vm._s(_vm.action)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }